import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/api/api";
import CustomNoRowsOverlay from "../../components/NoRows";
import AddInbound from "./_components/AddInbound";
import toast from "react-hot-toast";
import moment from "moment";
import successSound from "../../assets/audio/success.mp3";
import errorSound from "../../assets/audio/error.mp3";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const columns = [
  {
    field: "date",
    headerClassName: "header",
    headerName: "Date",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {moment(value).format("DD/MM/YYYY")}
      </Typography>
    ),
  },
  {
    field: "disposition",
    headerClassName: "header",
    headerName: "Disposition",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "supplier_name",
    headerClassName: "header",
    headerName: "Supplier",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "item_name",
    headerClassName: "header",
    headerName: "Item Name",
    width: 100,
    flex: 2,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "quantity",
    headerClassName: "header",
    headerName: "Qty",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "weight",
    headerClassName: "header",
    headerName: "Weight (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "total_weight",
    headerClassName: "header",
    headerName: "Total (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {parseInt(value).toLocaleString(["ban", "id"])}
      </Typography>
    ),
  },
  // {
  //   field: "price",
  //   headerClassName: "header",
  //   headerName: "Price (Rp/kg)",
  //   width: 100,
  //   flex: 1,
  //   renderCell: ({ value }) => (
  //     <Typography noWrap fontSize={14}>
  //       {parseInt(value).toLocaleString(["ban", "id"])}
  //     </Typography>
  //   ),
  // },
  // {
  //   field: "total_price",
  //   headerClassName: "header",
  //   headerName: "Total (Rp)",
  //   width: 100,
  //   flex: 1,
  //   renderCell: ({ value }) => (
  //     <Typography noWrap fontSize={14}>
  //       {parseInt(value).toLocaleString(["ban", "id"])}
  //     </Typography>
  //   ),
  // },
  {
    field: "_id",
    headerClassName: "header",
    headerName: "Action",
    width: 100,
    flex: 1,
    renderCell: () => (
      <button
        style={{
          color: "#fff",
          // fontFamily: "Murecho",
          fontWeight: "600",
          fontSize: "12px",
          border: "1px solid #222",
          borderRadius: "4px",
          backgroundColor: "#222",
          padding: "5px",
          cursor: "pointer",
        }}
      >
        See Details
      </button>
    ),
  },
];

const InboundList = () => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin_data"));
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };
  // const [data, setData] = useState([]);
  const todayDate = new Date();
  const formatDate = moment(todayDate).format("DD/MM/YYYY");
  const [inboundData, setInboundData] = useState([]);
  const [startDate, setStartDate] = useState("01/01/2024");
  const [endDate, setEndDate] = useState(formatDate);
  const [cleanStartDate, setCleanStartDate] = useState("");
  const [cleanEndDate, setCleanEndDate] = useState("");
  const limit = moment(todayDate).add(0, "days");
  const formattedLimit = moment(limit).format("YYYY-MM-DD");
  const successEffect = new Audio(successSound);
  const errorEffect = new Audio(errorSound);

  const fnEnd = (e) => {
    setEndDate(moment(e).format("DD/MM/YYYY"));
    setCleanEndDate(moment(e).format("L"));
  };

  const fnStart = (e) => {
    setStartDate(moment(e).format("DD/MM/YYYY"));
    setCleanStartDate(moment(e).format("L"));
  };

  const getDataByPeriod = async () => {
    await axiosInstance
      .get(
        `/api/inbounds?start_date=${startDate}&finish_date=${endDate}`,
        authentication,
      )
      .then((res) => {
        // console.log(res.data);
        if (res?.data.length === 0) {
          errorEffect.play();
          toast.error("No data found");
        } else {
          successEffect.play();
          toast.success(`${res?.data.length} data found`);
        }
        setInboundData(res.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Oops! Something is wrong. Please try again.");
      });
  };

  const getInbounds = async () => {
    await axiosInstance
      .get(
        // `/api/inbounds?start_date=${startDate}&finish_date=${endDate}`,
        `/api/inbounds`,
        authentication,
      )
      // .get("/api/inbounds/", authentication)
      .then((res) => {
        // console.log(res?.data);
        // setData(res?.data);
        setInboundData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getInbounds();
  }, []);

  return (
    <Box flex="1" sx={{ backgroundColor: "#f6f6f6" }}>
      <AddInbound
        open={modalOpen}
        setModalOpen={setModalOpen}
        refetch={getInbounds}
        // getInbounds={getInbounds}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        paddingX={3}
        sx={{ backgroundColor: "#F6F6F6" }}
        paddingY={2}
      >
        <Typography variant="h4" fontWeight="500">
          Inbounds
        </Typography>
        {user.role === "SuperAdmin" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Inbound Data
          </Button>
        )}
        {user.role === "Admin Warehouse" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Inbound Data
          </Button>
        )}
      </Stack>
      <Stack
        paddingX={3}
        gap={2}
        direction={"row"}
        justifyContent={"flex-start"}
      >
        <Stack gap={1}>
          <Typography fontSize={14}>Start date</Typography>
          <Stack sx={{ backgroundColor: "#FFF", width: "full" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnStart(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Stack gap={1}>
          <Typography fontSize={14}>End date</Typography>
          <Stack sx={{ backgroundColor: "#FFFF" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnEnd(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Button
          sx={{
            textTransform: "capitalize",
            borderRadius: "11px",
            backgroundColor: "#222",
            height: "40px",
            color: "#FFF",
            bottom: 0,
            marginTop: "28px",
            ":hover": {
              backgroundColor: "#444",
              color: "#FFF",
            },
          }}
          variant="contained"
          disabled={startDate === "" || endDate === "" ? true : false}
          onClick={() => getDataByPeriod()}
        >
          Get Data
        </Button>
      </Stack>
      <Stack>
        <Box
          sx={{
            "& .header": {
              backgroundColor: "#FFF",
              color: "#222",
            },
            "& .header-font": {
              backgroundColor: "#F6F6F6",
              color: "#F6F6F6",
            },
            padding: 3,
          }}
        >
          <DataGrid
            rows={inboundData}
            columns={columns}
            pageSize={pageSize}
            autoHeight
            getRowId={(rows) => rows._id}
            header
            pagination
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 15, 25]}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            onRowClick={(rows) =>
              navigate(`/warehouse/inbound/detail/${rows.row._id}`)
            }
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "none",
              color: "#535252",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default InboundList;
